<div class="flex column align-items-center gap-24 full-width">
  <div class="flex column align-items-center gap-8">
    <span class="typo-title-3">Import Backup</span>
    <span class="typo-text-3 text-medium text-align-center">
      Paste your backup key or upload your .key file
    </span>
  </div>

  <div class="backup-import-container flex column gap-16 full-width">
    <textarea
      class="backup-input"
      [(ngModel)]="backupData"
      placeholder="Paste your backup key here..."
      rows="6"
      [disabled]="isImporting()"
      spellcheck="false"
      autocomplete="off"
    ></textarea>

    <div class="flex align-items-center gap-12 full-width">
      <div class="divider"></div>
      <span class="typo-text-3 text-medium">or</span>
      <div class="divider"></div>
    </div>

    <kc-button
      class="upload-button"
      [text]="'Upload File'"
      [prefixIcon]="'icon-upload'"
      [variant]="'secondary'"
      [isFullWidth]="true"
      [isDisabled]="isImporting()"
      (buttonClick)="importFromFile()"
    />
  </div>

  <div class="flex gap-12 full-width">
    <kc-button
      [isFullWidth]="true"
      [text]="'Back'"
      [variant]="'secondary'"
      (buttonClick)="previous.emit()"
      [isDisabled]="isImporting()"
    />
    <kc-button
      [isFullWidth]="true"
      [text]="isImporting() ? 'Importing...' : 'Import'"
      [variant]="'primary'"
      (buttonClick)="importBackup()"
      [isDisabled]="isImporting() || !backupData.trim()"
    />
  </div>
</div>
